import React from 'react';
import styles from './InventoryLoader.module.css';

const InventoryLoader: React.FC = () => {
  return (
    <div className={styles.loaderContainer}>
      <div className={styles.flowContainer}>
        {/* Step 1: Supplier / Requisition */}
        <div className={`${styles.node} ${styles.blueNode}`}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
        </div>
        
        {/* Connecting Line 1 */}
        <div className={styles.connectionLine}>
          <div className={`${styles.dot} ${styles.dot1}`}></div>
        </div>

        {/* Step 2: Warehouse / GRN / Stock */}
        <div className={`${styles.node} ${styles.greenNode}`}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="21" y1="10" x2="3" y2="10"></line>
            <line x1="21" y1="6" x2="3" y2="6"></line>
            <line x1="21" y1="14" x2="3" y2="14"></line>
            <line x1="21" y1="18" x2="3" y2="18"></line>
            <path d="M12 22v-4"></path>
            <path d="M12 6V2"></path>
          </svg>
        </div>

        {/* Connecting Line 2 */}
        <div className={styles.connectionLine}>
          <div className={`${styles.dot} ${styles.dot2}`}></div>
        </div>

        {/* Step 3: Dispense / Transfer */}
        <div className={`${styles.node} ${styles.orangeNode}`}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </div>
      </div>
      
      <div className={styles.loadingText}>
        <span>Processing Inventory Network</span>
        <span className={styles.ellipsis}>...</span>
      </div>
    </div>
  );
};

export default InventoryLoader;

